// tslint:disable: ordered-imports
import {
    Button,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    Paper,
    TextField,
    Typography
} from '@material-ui/core';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import {
    AddCommentOutlined,
    ClearOutlined,
    DeleteForeverOutlined,
    ForumOutlined,
    Fullscreen,
    FullscreenExit,
    InfoOutlined,
    RoomRounded,
    SearchOutlined,
    SendOutlined
} from '@material-ui/icons';
import { Theme } from '@material-ui/core/styles';
import * as React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { LeafletPDFData, PDFApiMarker } from '../../providers/floorplan.provider';
import { MarkerOperation } from '../thin-client/thin-client';
import L, {
    LatLngExpression,
    LeafletMouseEvent,
    DragEndEvent,
    LayerGroup,
    Map,
    LatLng,
    LatLngBounds
} from 'leaflet';
import 'leaflet/dist/leaflet.css';
import ReactDOMServer from 'react-dom/server';
import { v4 as uuidv4 } from 'uuid';

interface LeafletMarker {
    id: string;
    room_type: string;
    name: string;
    coordinates: string;
    out_of_bounds: string;
    xfdf_coordinates: string;
    is_new: boolean;
    map_marker: L.Marker<any>;
}

interface ImageIntegrityCheck {
    flag: boolean;
    width: number;
    height: number;
}

const styles = (theme: Theme) =>
    createStyles({
        [theme.breakpoints.down('lg')]: {
            markerListHolder: {
                maxHeight: '50em !important'
            },
            markerListHolderFull: {
                maxHeight: '50em !important'
            },
            fullScreenAddCommentButton: {
                top: '13%',
                left: '0.9%'
            },
            paperFrame: {
                maxHeight: '50em !important'
            },
        },
        animContainer: {
            transition: 'width 0.5s'
        },
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            transition: 'all 1s !important'
        },
        container: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        heading: {
            fontWeight: 700,
            height: 'min-content',
            display: 'inline'
        },
        ellipsis: {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        buttonFullscreen: {
            float: 'left',
            minWidth: '1em',
            marginRight: '1em'
        },
        buttonExport: {
            float: 'right',
            marginLeft: 'auto'
        },
        buttonContainer: {
            marginTop: '1.5em',
            marginBottom: '0.5em'
        },
        fullScreenContainer: {
            position: 'fixed',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            margin: 'auto !important',
            zIndex: 9999,
            '& $paperFrame': {
                maxHeight: 'unset !important',
            }
        },
        paperFrame: {
            height: '90%',
            minWidth: '60em',
            position: 'relative',
            display: 'flex',
            maxHeight: '55em',
            '& #map': {
                height: '100%'
            }
        },
        buttonContainerFullscreen: {
            background: 'white',
            margin: 0,
            padding: '0.5em 0'
        },
        warningItem: {
            color: '#ffc409'
        },
        warningText: {
            color: 'darkorange'
        },
        readyItem: {
            color: '#2dd36f'
        },
        readyText: {
            color: 'darkgreen'
        },
        flexItem: {
            display: 'flex',
            alignItems: 'center'
        },
        warningToast: {
            whiteSpace: 'break-spaces'
        },
        leafletClientFlag: {
            marginLeft: '1em',
            '& small': {
                marginLeft: '0.5em',
                fontWeight: 'bold',
                opacity: 0,
                transition: 'opacity 1s',
                animation: '$fadeInfo 7s',
                animationDelay: '1s'
            },
            '&:hover > small': {
                opacity: 1
            }
        },
        '@keyframes fadeInfo': {
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            }
        },
        leafletClientHolder: {
            width: 'auto',
            flex: 1,
            maxHeight: '100vh'
        },
        markerListHolder: {
            width: '35%',
            maxHeight: '100vh'
        },
        markerListHolderHidden: {
            width: '0%'
        },
        markerListHolderFull: {
            width: '35%',
            maxHeight: '100vh'
        },
        markerIconNormal: {
            height: '35px !important',
            width: '35px !important',
            color: '#ee7830',
            filter: 'drop-shadow( 3px 3px 2px rgba(0, 0, 0, .3))',
            stroke: '#fff',
            strokeWidth: '1px',
        },
        markerIconSelected: {
            height: '35px !important',
            width: '35px !important',
            color: '#45d711',
            filter: 'drop-shadow( 3px 3px 2px rgba(0, 0, 0, .3))',
            stroke: '#fff',
            strokeWidth: '1px',
        },
        markerIconError: {
            height: '35px !important',
            width: '35px !important',
            color: '#ff0000',
            filter: 'drop-shadow( 3px 3px 2px rgba(0, 0, 0, .3))',
            stroke: '#fff',
            strokeWidth: '1px',
        },
        addCommentButton: {
            boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.29)',
            position: 'absolute',
            top: '12%',
            zIndex: 999,
            background: 'white',
            borderRadius: '5px',
            padding: '5px',
            left: '1.1%',
            ':hover': {
                backgroundColor: 'rgb(183, 255, 202)'
            }
        },
        addCommentButtonSelected: {
            boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.29)',
            position: 'absolute',
            top: '12%',
            zIndex: 999,
            background: 'rgb(30, 236, 84)',
            borderRadius: '5px',
            padding: '5px',
            left: '1.1%',
            ':hover': {
                backgroundColor: 'rgb(30, 236, 84)'
            }
        },
        fullScreenAddCommentButton: {
            top: '11%',
            left: '0.5%'
        },
        showMarkerListButton: {
            boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.29)',
            position: 'absolute',
            top: '1.5%',
            zIndex: 999,
            background: 'white',
            borderRadius: '5px',
            padding: '5px',
            right: '1.5%',
        },
        searchInput: {
            width: '100%'
        },
        editMarkerInput: {
            width: '100%',
            padding: 0,
            '& .MuiIconButton-label': {
                padding: '0 !important',
                color: '#009933 !important'
            }
        },
        listHeader: {
            padding: '2em 2em 1em 0.5em',
            position: 'static'
        },
        listHeaderText: {
            color: '#2f2f2f !important',
            fontWeight: 'normal'
        },
        markerListitem: {
            padding: '1.5em 1em',
            '& span': {
                fontWeight: 400,
                lineHeight: 1.43,
                letterSpacing: '0.01071em',
                fontSize: '0.86rem',
                color: '#4b4b4bbf',
                paddingBottom: '0.5em'
            },
            '& p': {
                fontWeight: 700,
                lineHeight: 1.5,
                letterSpacing: '0.00938em',
                fontSize: '1rem',
                color: '#4b4b4b'
            },
            '&:focus': {
                background: '#fffaee'
            }
        },
        listItemDeleteIcon: {
            minWidth: 'unset',
            color: '#eb445a'
        },
        markerListComponent: {
            height: '100%',
            overflowY: 'scroll'
        },
        markerListEditItem: {
            padding: '1.5em 1em',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'baseline',
            '& span': {
                fontWeight: 400,
                lineHeight: 1.43,
                letterSpacing: '0.01071em',
                fontSize: '0.86rem',
                color: 'rgba(0, 0, 0, 0.87)',
                paddingBottom: '0.5em'
            },
            '& p': {
                fontWeight: 700,
                lineHeight: 1.5,
                letterSpacing: '0.00938em',
                fontSize: '1rem',
                color: '#4b4b4b'
            }
        },
        closeMarkerListButton: {
            marginRight: '0.5em'
        }
    });

interface Props extends WithStyles<typeof styles> {
    className: string;
    floorplanName: string;
    floorplanId: string;
    floorplanPayload: LeafletPDFData;
    onFinishMarkerOperations?: (
        markerOperations: MarkerOperation[],
        updatedFileBlob: Blob
    ) => void;
    warningText?: string;
}

interface States {
    partialOperations: MarkerOperation[];
    isWarning: boolean;
    warningText: string;
    isFullScreen: boolean;
    isSavingChanges: boolean;
    leafletMarkers: LeafletMarker[];
    errorMarkers: LeafletMarker[];
    selectedMarker: LeafletMarker | null;
    floorplanBounds: LatLngBounds | null;
    isAddButtonClicked: boolean;
    isAddingNewMarker: boolean;
    mapComponent: Map | null;
    markersGroup: LayerGroup | null;
    markerSearch: string;
    isEditingMarker: boolean;
    normalMarkerIcon: L.DivIcon;
    selectedMarkerIcon: L.DivIcon;
    errorMarkerIcon: L.DivIcon;
    isMarkerListOpened: boolean;
}

class LeafletPDFClient extends React.Component<Props, States> {
    public static defaultProps = {};

    state: States = {
        partialOperations: [],
        isWarning: false,
        warningText: '',
        isFullScreen: false,
        isSavingChanges: false,
        leafletMarkers: [],
        errorMarkers: [],
        selectedMarker: null,
        floorplanBounds: null,
        isAddButtonClicked: false,
        isAddingNewMarker: false,
        mapComponent: null,
        markersGroup: null,
        markerSearch: '',
        isEditingMarker: false,
        normalMarkerIcon: null as unknown as L.DivIcon,
        selectedMarkerIcon: null as unknown as L.DivIcon,
        errorMarkerIcon: null as unknown as L.DivIcon,
        isMarkerListOpened: true
    };

    isImageLandscape = (base64String: string): Promise<ImageIntegrityCheck> => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                resolve({
                    flag: img.width > img.height,
                    width: img.width,
                    height: img.height
                });
            };
            img.onerror = err => reject(err);
            img.src = `data:image/png;base64,${base64String}`;
        });
    };

    componentDidMount() {
        const { warningText, classes, floorplanPayload } = this.props;
        if (warningText) {
            this.setState({ isWarning: true, warningText });
        }
        const normalIcon = L.divIcon({
            html: ReactDOMServer.renderToString(<RoomRounded className={classes.markerIconNormal}/>),
            className: classes.markerIconNormal,
            iconSize: [35, 35],
            iconAnchor: [15, 35],
        });
        const selectedIcon = L.divIcon({
            html: ReactDOMServer.renderToString(<RoomRounded className={classes.markerIconSelected}/>),
            className: classes.markerIconSelected,
            iconSize: [35, 35],
            iconAnchor: [15, 35],
        });
        const errorIcon = L.divIcon({
            html: ReactDOMServer.renderToString(<RoomRounded className={classes.markerIconError}/>),
            className: classes.markerIconError,
            iconSize: [35, 35],
            iconAnchor: [15, 35],
        });
        this.setState({
            normalMarkerIcon: normalIcon,
            selectedMarkerIcon: selectedIcon,
            errorMarkerIcon: errorIcon
        }, () => {
            this.isImageLandscape(floorplanPayload.pdf.image).then(flag => {
                this.initializeLeafletClient(flag, floorplanPayload);
            })
        });
    }

    initializeLeafletClient = async (imageFlag: ImageIntegrityCheck, floorplanPayload: LeafletPDFData) => {
        // NEW CALCULATIONS BASED ON INCONSISTENCIES FOUND AT CPS
        // ISSUES ADDRESSED HERE:
        // 1. PDF FILES WITH INCONSISTENT ROTATIONS
        //      - A PDF FILE CAN BE ROTATED BUT THE ROTATION IS NOT STORED PROPERLY ON THE METADA 
        //      - FIXED WITH CHECKING IF THE IMAGE IS LANDSCAPE BUT THE PDF ISN'T
        // 2. PDF FILES WITH INCONSISTENT MEDIABOX / MISSMATCH DIMENSIONS 
        //      - A PDF FILE CAN HAVE INCORRECT DIMENSIONS STORED AS PART OF A CROP OPERATION OR CORRUPTED METADATA
        //      - FIXED BY RELYING ON CROPBOX INSTEAD OF MEDIABOX
        //      - EXAMPLE: A LANDSCAPE PDF MUCH WIDER THAN TALLER HAS THE FOLLOWING DATA
        //      CROPBOX: [4.44566,36.131401,778.729981,377.757996] vs MEDIABOX: [0.0,0.0,797.236023,618.109009]
        //      WITH A VISIBLE DISCREPANCY OF HEIGHT 341 (LANDSCAPE) VS 618 (PORTRAIT) 
        //      SO WE USE CROPBOX WHICH WILL ALWAYS REPRESENT THE VISIBLE AREA OF THE PDF

        const { width: imgWidth, height: imgHeight } = imageFlag;
        const { rotation, cropbox } = floorplanPayload.pdf.dimensions;

        const [x0, y0, x1, y1] = cropbox;
        let pdfWidth = Math.abs(x1 - x0);
        let pdfHeight = Math.abs(y1 - y0);
        
        if (rotation === 90 || rotation === 270) {
            [pdfWidth, pdfHeight] = [pdfHeight, pdfWidth];
        }

        // Sometimes the rotation value is incorrect or incomplete, so double-check
        const imageIsLandscape = imgWidth > imgHeight;
        const pdfIsPortrait = pdfHeight > pdfWidth;

        // If image is landscape but bounds are portrait, swap again
        if (imageIsLandscape && pdfIsPortrait) {
            [pdfWidth, pdfHeight] = [pdfHeight, pdfWidth];
        }

        const mapBounds = L.latLngBounds([[0, 0], [pdfHeight, pdfWidth]]);
        const zoomPadding = 0.3;
        const zoomValue = Math.max(pdfWidth, pdfHeight) * zoomPadding;
        const zoomBounds = L.latLngBounds([
            [-zoomValue, -zoomValue],
            [mapBounds.getNorth() + zoomValue, mapBounds.getEast() + zoomValue]
        ]);
        
        // ================================== OLD CALCULATIONS =========================
        // let topX, topY;
        // if (floorplanPayload.pdf.dimensions.rotation === 0 || floorplanPayload.pdf.dimensions.rotation === 180) {
        //     topX = floorplanPayload.pdf.dimensions.mediabox[3];
        //     topY = floorplanPayload.pdf.dimensions.mediabox[2];
        // } else {
        //     topX = floorplanPayload.pdf.dimensions.mediabox[2];
        //     topY = floorplanPayload.pdf.dimensions.mediabox[3];
        // }

        // // CHECK FOR LANDSCAPE IMAGE ISSUES WITH INCORRECT MEDIA BOX
        // // THIS ISSUE HAPPENS WHEN THE ROTATION OF A PDF DOESN'T REFLECT THE COORDINATE SYSTEM
        // if (isImageLandscape && topX > topY) {
        //     [topY, topX] = [topX, topY];
        // }

        // const mapBounds = L.latLngBounds([
        //     [
        //         floorplanPayload.pdf.dimensions.mediabox[0],
        //         floorplanPayload.pdf.dimensions.mediabox[1]
        //     ],
        //     [
        //         topX,
        //         topY
        //     ]
        // ]);

        // const zoomValue = floorplanPayload.pdf.dimensions.mediabox[2] * 0.3;
        // const zoomBounds = L.latLngBounds([
        //     [
        //         floorplanPayload.pdf.dimensions.mediabox[0] - zoomValue,
        //         floorplanPayload.pdf.dimensions.mediabox[1] - zoomValue
        //     ],
        //     [
        //         topX + zoomValue,
        //         topY + zoomValue
        //     ]
        // ]);
        // ================================== OLD CALCULATIONS =========================

        const map = L.map('map', {
            crs: L.CRS.Simple,
            minZoom: -0.25,
            maxBounds: zoomBounds,
            maxBoundsViscosity: 1.0,
            trackResize: true
        });

        map.setZoom(0);

        const b64Image = `data:image/png;base64,${floorplanPayload.pdf.image}`;
        const image = L.imageOverlay(b64Image, mapBounds);
        image.addTo(map);
        map.fitBounds(mapBounds);

        const markersGroup = L.layerGroup().addTo(map) as LayerGroup;
        map.on('click', (event: LeafletMouseEvent) => {
            this.addNewMarker(event);
        });

        this.setState(
            {
                markersGroup,
                mapComponent: map,
                floorplanBounds: mapBounds
            },
            () => {
                this.renderMarkers();
            }
        );
    };

    bringMarkerToBounds = (markerPos: L.LatLngExpression, bounds: LatLngBounds): LatLngExpression => {
        const markerLatLng = L.latLng(markerPos);

        const southWest = bounds.getSouthWest();
        const northEast = bounds.getNorthEast();

        const paddedSouthWest = L.latLng(southWest.lat + 0.5, southWest.lng + 0.5);
        const paddedNorthEast = L.latLng(northEast.lat - 0.5, northEast.lng - 0.5);

        const clampedLat = Math.max(
            paddedSouthWest.lat,
            Math.min(markerLatLng.lat, paddedNorthEast.lat)
        );
        const clampedLng = Math.max(
            paddedSouthWest.lng,
            Math.min(markerLatLng.lng, paddedNorthEast.lng)
        );

        return [clampedLat + 30, clampedLng + 30] as LatLngExpression;
    };

    createLeafletMarker = (markerData: PDFApiMarker, isNewMarker: boolean): LeafletMarker | null=> {
        const {
            normalMarkerIcon,
            errorMarkerIcon,
            floorplanBounds,
            errorMarkers
        } = this.state;
        const {
            coordinates,
            id,
            name,
            xfdf_coordinates,
            out_of_bounds,
            room_type
        } = markerData;

        if (!floorplanBounds) {
            return null;
        }

        let position = coordinates
            .split(',')
            .map(e => Number(e)) as LatLngExpression;

        let withinBounds = true;
        if (!floorplanBounds.contains(position)) {
            position = this.bringMarkerToBounds(position, floorplanBounds);
            withinBounds = false;
        }

        const markerMap = L.marker(position, {
            icon: withinBounds ? normalMarkerIcon : errorMarkerIcon,
            draggable: true
        });

        const leafletMarker: LeafletMarker = {
            id,
            name,
            coordinates,
            xfdf_coordinates,
            out_of_bounds: out_of_bounds,
            room_type,
            map_marker: markerMap,
            is_new: isNewMarker
        };

        if (!withinBounds) {
            errorMarkers.push(leafletMarker);

            this.setState({ errorMarkers });
        }
        
        markerMap.bindTooltip(name);
        markerMap.on('dragstart', e => 
            this.setState({isEditingMarker: false})
        );
        markerMap.on('dragend', e =>
            this.onMarkerMoveEvent(e, leafletMarker)
        );
        markerMap.on('click', e =>
            this.onMarkerClickEvent(e, leafletMarker)
        );
        markerMap.on('dblclick', e =>
            this.onMarkerStartEditing(leafletMarker)
        );

        return leafletMarker
    };

    renderMarkers = () => {
        const { floorplanPayload } = this.props;

        const { markersGroup } = this.state;

        if (!markersGroup) {
            return;
        }
        const { markers } = floorplanPayload;
        const leafletMarkers: LeafletMarker[] = [];

        const markerNames = new Set<string>();
        const markerNameDupps: PDFApiMarker[] = [];

        markers.forEach(marker => {
            if (markerNames.has(marker.name)) {
                markerNameDupps.push(marker);
            }

            markerNames.add(marker.name);

            const leafletMarker = this.createLeafletMarker(marker, false);

            if (!leafletMarker) {
                return;
            }

            leafletMarkers.push(leafletMarker);

            leafletMarker.map_marker.addTo(markersGroup);
        });

        const { errorMarkers } = this.state;
        let boundsWarning = false;
        let boundsWarningText = '';

        if (errorMarkers.length > 0) {
            boundsWarning = true;
            boundsWarningText = 'Some markers were found out of pdf bounds, they were highlighted in BRIGHT RED to submit changes the markers need to be fixed:';

            errorMarkers.forEach(e => {
                boundsWarningText += '\n' + `- ${e.name}`;
            });
        }

        if (markerNameDupps.length > 0) {
            boundsWarning = true;
            boundsWarningText = 'Some markers were found with duplicat names to submit changes the markers need to be fixed:';

            markerNameDupps.forEach(e => {
                boundsWarningText += '\n' + `- ${e.name}`;
            });
        }

        this.setState({
            leafletMarkers,
            selectedMarker: null,
            markersGroup,
            isWarning: boundsWarning,
            warningText: boundsWarningText
        });
    };

    addNewMarker = (event: LeafletMouseEvent) => {
        const {
            isAddButtonClicked,
            markersGroup,
            leafletMarkers,
            normalMarkerIcon,
            selectedMarkerIcon,
            floorplanBounds
        } = this.state;

        let { selectedMarker } = this.state;

        this.setState({isEditingMarker: false});

        if (!isAddButtonClicked || !floorplanBounds) {
            return;
        }

        const markerMapPosition = event.latlng;

        if (
            markerMapPosition.lat < 0 ||
            markerMapPosition.lng < 0 ||
            !markersGroup
        ) {
            return;
        }

        // CHECK IF MARKER IS OUT OF BOUNDS
        if (!floorplanBounds.contains(markerMapPosition)) {
            // DISPLAY WARNING
            this.setState({
                isWarning: true,
                warningText: 'Cannot create a marker out of bounds'
            });
            return;
        }

        const markerCoords = [markerMapPosition.lat, markerMapPosition.lng];
        const newMarker = this.createLeafletMarker({
            id: uuidv4(),
            name: '',
            coordinates: markerCoords.join(','),
            out_of_bounds: 'false',
            room_type: '',
            xfdf_coordinates: '',
        }, true)

        if (selectedMarker) {
            selectedMarker.map_marker.setIcon(normalMarkerIcon);
            selectedMarker.map_marker.closeTooltip();
        }

        if (!newMarker) {
            return;
        }

        newMarker.map_marker.setIcon(selectedMarkerIcon);
        newMarker.map_marker.addTo(markersGroup);
        leafletMarkers.push(newMarker);
        this.setState({
            markersGroup,
            selectedMarker: {...newMarker},
            leafletMarkers,
            isEditingMarker: true,
            isAddButtonClicked: false,
            markerSearch: ''
        });
    };

    onMarkerMoveEvent = (event: DragEndEvent, marker: LeafletMarker) => {
        const { floorplanId } = this.props;
        const {
            leafletMarkers,
            partialOperations,
            mapComponent,
            floorplanBounds,
            selectedMarker,
            selectedMarkerIcon,
            normalMarkerIcon
        } = this.state;

        const markerToUpdate = leafletMarkers.find(e => e.id === marker.id);

        if (!markerToUpdate || !mapComponent || !floorplanBounds) {
            return;
        }

        const editedPosition = event.target.getLatLng() as LatLng;

        // CHECK IF MARKER IS WITHIN BOUNDS
        if (!floorplanBounds.contains(editedPosition)) {
            // RETURN TO ORIGINAL POSITION
            const previousPosition = markerToUpdate.coordinates.split(",").map(e => Number(e)) as LatLngExpression;
            markerToUpdate.map_marker.setLatLng(previousPosition);

            // DISPLAY WARNING
            this.setState({
                isWarning: true,
                warningText: 'Cannot move a marker out of bounds'
            });
            return;
        }
        
        const existingOperation = partialOperations.find(
            e => e.marker_id === marker.id
        );

        const newCoordinates = `${editedPosition.lat},${editedPosition.lng}`;
        markerToUpdate.coordinates = newCoordinates;
        if (existingOperation) {
            existingOperation.coordinates = newCoordinates;
        } else {
            const newItem: MarkerOperation = {
                floorplan_id: floorplanId,
                marker_id: markerToUpdate.id,
                verb: 'UPDATE',
                name: markerToUpdate.name,
                coordinates: markerToUpdate.coordinates
            };

            partialOperations.push(newItem);
        }

        // HIGHLIGHT THE MOVED MARKER
        if (selectedMarker && selectedMarker.id !== markerToUpdate.id) {
            selectedMarker.map_marker.setIcon(normalMarkerIcon);
            selectedMarker.map_marker.closeTooltip();
            markerToUpdate.map_marker.setIcon(selectedMarkerIcon);
        }
        this.setState({
            partialOperations,
            leafletMarkers,
            selectedMarker: {...markerToUpdate}
        });
    };

    onMarkerClickEvent = (event: LeafletMouseEvent, marker: LeafletMarker) => {
        let { selectedMarker, normalMarkerIcon, selectedMarkerIcon } = this.state;

        if (selectedMarker && selectedMarker.id === marker.id) {
            return;
        }

        marker.map_marker.setIcon(selectedMarkerIcon);

        if (selectedMarker) {
            selectedMarker.map_marker.setIcon(normalMarkerIcon);
        }
        // AVOID TWO-WAY DATA BINDING
        selectedMarker = {...marker};
        marker.map_marker.openTooltip();
        this.setState({ selectedMarker, isEditingMarker: false  });
    };

    onFullscreenClick = () => {
        const { isFullScreen, mapComponent } = this.state;

        if (!mapComponent) {
            return;
        }
        this.setState(
            {
                isFullScreen: !isFullScreen
            },
            () => {
                mapComponent.invalidateSize({
                    debounceMoveend: true,
                    pan: false
                });
            }
        );
    };

    onFinishMarkerOperations = () => {
        const { partialOperations } = this.state;
        const { onFinishMarkerOperations } = this.props;

        this.setState({
            isFullScreen: false
        });

        if (onFinishMarkerOperations) {
            onFinishMarkerOperations(
                partialOperations,
                (null as unknown) as Blob
            );
        }
    };

    onCloseWarning = () => {
        this.setState({
            isWarning: false,
            warningText: ''
        });
    };

    startAddNewMarker = () => {
        const { isAddButtonClicked, isAddingNewMarker } = this.state;

        this.setState({
            isAddButtonClicked: !isAddButtonClicked,
            isAddingNewMarker: !isAddingNewMarker
        });
    };

    keyDeleteMarker = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const { code } = event;

        if (code !== 'Delete' && code !== 'Backspace') {
            return;
        }

        const {
            selectedMarker,
            leafletMarkers,
            markersGroup
        } = this.state;

        if (!selectedMarker || !markersGroup) {
            return;
        }

        const delMarker = leafletMarkers.find(e => e.id === selectedMarker.id);

        if (!delMarker) {
            return;
        }

        // MOVE ALL DELETE MARKER LOGIC TO A SINGLE FUNCTION
        this.itemDeleteMarker(delMarker);
    };

    itemDeleteMarker = (marker: LeafletMarker) => {
        const { floorplanId } = this.props;
        const { leafletMarkers, markersGroup, partialOperations } = this.state;
        let { selectedMarker } = this.state;
        if (!markersGroup) {
            return;
        }

        const markerToRemove = leafletMarkers.find(e => e.id === marker.id);

        if (!markerToRemove) {
            return;
        }

        const markerToRemoveIndex = leafletMarkers.findIndex(
            e => e.id === marker.id
        );
        leafletMarkers.splice(markerToRemoveIndex, 1);
        markersGroup.removeLayer(markerToRemove.map_marker);

        if (selectedMarker && selectedMarker.id === markerToRemove.id) {
            selectedMarker = null;
        }

        // IF THIS IS A NEWLY CREATED MARKER ON THIS SESSION
        // THERE WILL BE AN ADD JOB THAT NEEDS TO GET REMOVED
        // SO THAT WE DON'T ISSUE DELETES FOR MARKERS THAT EXISTS YET
        if (marker.is_new) {
            const existingOperationIndex = partialOperations.findIndex(e => e.marker_id === marker.id);
            partialOperations.splice(existingOperationIndex, 1);
        } else {
            const existingOperation = partialOperations.find(e => e.marker_id === marker.id);
    
            if (existingOperation) {
                existingOperation.verb = 'DELETE';
            } else {
                const newItem: MarkerOperation = {
                    floorplan_id: floorplanId,
                    marker_id: markerToRemove.id,
                    verb: 'DELETE',
                    name: markerToRemove.name,
                    coordinates: markerToRemove.coordinates
                };
                partialOperations.push(newItem);
            }
        }

        this.setState({
            selectedMarker: null,
            leafletMarkers,
            markersGroup,
            partialOperations
        });
    };

    onCancelSearch = () => {
        const { markerSearch } = this.state;

        if (!markerSearch) {
            return;
        }

        this.setState({ markerSearch: '' });
    };

    onMarkerNameSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const searchValue = event.target.value;

        this.setState({
            markerSearch: searchValue
        });
    };

    onMarkerItemFocus = (marker: LeafletMarker) => {
        const { markersGroup, leafletMarkers, normalMarkerIcon, selectedMarkerIcon } = this.state;
        let { selectedMarker } = this.state;

        if (!markersGroup) {
            return;
        }

        const clickedMarker = leafletMarkers.find(e => e.id === marker.id);

        if (!clickedMarker) {
            return;
        }

        if (!selectedMarker || selectedMarker.id !== clickedMarker.id) {
            clickedMarker.map_marker.setIcon(selectedMarkerIcon);

            if (selectedMarker) {
                selectedMarker.map_marker.setIcon(normalMarkerIcon);
                selectedMarker.map_marker.closeTooltip();
            }
            // AVOID TWO-WAY DATA BINDING
            selectedMarker = {...clickedMarker};
            clickedMarker.map_marker.openTooltip();

            this.setState({ selectedMarker, isEditingMarker: false });
            return;
        }
    };

    onMarkerStartEditing = (marker: LeafletMarker) => {
        const { markersGroup, leafletMarkers, normalMarkerIcon, selectedMarkerIcon } = this.state;
        let { selectedMarker } = this.state;

        if (!markersGroup) {
            return;
        }

        const clickedMarker = leafletMarkers.find(e => e.id === marker.id)!;

        if (!selectedMarker || selectedMarker.id !== clickedMarker.id) {
            clickedMarker.map_marker.setIcon(selectedMarkerIcon);

            if (selectedMarker) {
                selectedMarker.map_marker.setIcon(normalMarkerIcon);
                selectedMarker.map_marker.closeTooltip();
            }
            // AVOID TWO-WAY DATA BINDING
            selectedMarker = {...clickedMarker};
            clickedMarker.map_marker.openTooltip();
        }

        this.setState({
            selectedMarker,
            isEditingMarker: true
        });
    };

    formatMarkerItemList = () => {
        const { leafletMarkers, markerSearch } = this.state;

        let listMarkerSorted = leafletMarkers.sort((a, b): number => {
            const keyA = a.name.toUpperCase();
            const keyB = b.name.toUpperCase();

            if (keyA < keyB) {
                return -1;
            }
            if (keyA > keyB) {
                return 1;
            }

            return 0;
        });

        if (markerSearch !== '') {
            listMarkerSorted = listMarkerSorted.filter(e =>
                e.name.toUpperCase().includes(markerSearch.toUpperCase())
            );
        }

        return listMarkerSorted;
    };

    onMarkerEditChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        const { selectedMarker } = this.state;

        if (!selectedMarker) {
            return;
        }

        selectedMarker.name = inputValue;
        this.setState({ selectedMarker });
    };

    onMarkerInputBlur = () => {
        const {
            selectedMarker,
            partialOperations,
            leafletMarkers,
            markersGroup,
            normalMarkerIcon
        } = this.state;

        if (!selectedMarker || !markersGroup) {
            return;
        }

        const existingName = leafletMarkers.find(
            e =>
                e.name.toUpperCase().replace(/^\s+|\s+$/g, '') ===
                selectedMarker.name.toUpperCase().replace(/^\s+|\s+$/g, '') &&
                e.id !== selectedMarker.id
        );

        if (existingName) {
            // REVERSE THE NAME AND PREVENT THE OPERATION
            selectedMarker.map_marker.setIcon(normalMarkerIcon);
            selectedMarker.map_marker.closeTooltip();

            const correspondingMarker = leafletMarkers.find(e => selectedMarker.id);

            if (!correspondingMarker || correspondingMarker.name !== '') {
                this.setState({
                    selectedMarker: null,
                    isAddingNewMarker: false,
                    isAddButtonClicked: false,
                    isEditingMarker: false,
                    isWarning: true,
                    warningText: 'You cannot rename a marker to an already existing name'
                });
                return;
            }
            
            // THIS MARKER DOESN'T HAVE A PREVIOUS NAME
            // SINCE WE DON'T ALLOW EMPTY NAMES REMOVE IT FROM THE MAP
            // IN THE NEXT STEP
            selectedMarker.name = '';
        }

        if (selectedMarker.name === '') {
            markersGroup.removeLayer(selectedMarker.map_marker);
            const operationIndex = partialOperations.findIndex(e => e.marker_id === selectedMarker.id);
            const leafletMarkerIndex = leafletMarkers.findIndex(e => e.id === selectedMarker.id);

            if (operationIndex >= 0) {
                partialOperations.splice(operationIndex, 1);
            }

            if (leafletMarkerIndex >= 0) {
                leafletMarkers.splice(leafletMarkerIndex, 1);
            }

            this.setState({
                selectedMarker: null,
                isAddingNewMarker: false,
                isAddButtonClicked: false,
                isEditingMarker: false,
                partialOperations,
                leafletMarkers
            });
            return;
        }

        // IF WE HAVE REACHED THIS POINT IT MEANS THE USER HAS TYPED A NAME
        // BUT IT HASN'T SUBMITTED IT, SO WE ADD IT TO THE CHANGE SET FOR THEM
        this.onMarkerEditSubmit(false);
    };

    onMarkerEditSubmit = (
        isKeboardEvent: boolean,
        event?: React.KeyboardEvent<HTMLDivElement>
    ) => {
        if (isKeboardEvent && event) {
            const { code } = event;

            if (code === 'Escape') {
                this.onMarkerInputBlur();
                return;
            }
            if (code !== 'Enter') {
                return;
            }
        }

        const {
            selectedMarker,
            leafletMarkers,
            isAddingNewMarker,
            partialOperations
        } = this.state;

        if (!selectedMarker) {  
            return;
        }

        if (selectedMarker.name === '') {
            // REMOVE AN EMPTY NAME MARKER
            this.onMarkerInputBlur();
        }

        const { floorplanId } = this.props;

        const listMarker = leafletMarkers.find(e => e.id === selectedMarker.id);

        if (!listMarker) {
            return;
        }

        const existingName = leafletMarkers.find(
            e =>
                e.name.toUpperCase().replace(/^\s+|\s+$/g, '') ===
                selectedMarker.name.toUpperCase().replace(/^\s+|\s+$/g, '') &&
                e.id !== selectedMarker.id
        );

        if (existingName) {
            this.setState({
                isWarning: true,
                warningText: 'You cannot rename a marker to an already existing name'
            });

            return;
        }

        listMarker.name = selectedMarker.name;
        selectedMarker.map_marker.bindTooltip(selectedMarker.name);

        const existingOperation = partialOperations.find(
            e => e.marker_id === selectedMarker.id
        );

        if (existingOperation) {
            existingOperation.name = selectedMarker.name;
        } else {
            const newItem: MarkerOperation = {
                floorplan_id: floorplanId,
                marker_id: selectedMarker.id,
                verb: '',
                name: selectedMarker.name,
                coordinates: selectedMarker.coordinates
            };

            if (isAddingNewMarker) {
                newItem.verb = 'ADD';
            } else {
                newItem.verb = 'UPDATE';
            }

            partialOperations.push(newItem);
        }

        this.setState({
            leafletMarkers,
            isEditingMarker: false,
            isAddingNewMarker: false,
            partialOperations
        });
    };

    onMarkerListholderHideClick = () => {
        const { isMarkerListOpened, mapComponent } = this.state;

        if (!mapComponent) {
            return;
        }

        this.setState({isMarkerListOpened: !isMarkerListOpened}, () => {
            setTimeout(() => {
                mapComponent.invalidateSize({
                    debounceMoveend: true,
                    pan: false
                });
            }, 550);
        });
    };

    checkCanSaveChanges = () => {
        const { errorMarkers, isSavingChanges, partialOperations, floorplanBounds, leafletMarkers } = this.state;

        if (!floorplanBounds) {
            return true;
        }

        if (isSavingChanges) {
            return true;
        }
        
        const markerNames = new Set<string>();

        for (const e of leafletMarkers) {
            if (markerNames.has(e.name)) {
                return true;
            }
    
            markerNames.add(e.name);
        }
        
        if (errorMarkers.length <= 0) {
            return false;
        } 

        const errorMarkerIds = errorMarkers.map(e => e.id);
        const errorMarkersChanged = partialOperations.filter(e => errorMarkerIds.includes(e.marker_id));

        if (errorMarkers.length !== errorMarkersChanged.length) {
            return true;
        }

        for (const e of errorMarkerIds) {
            const mapMarker = leafletMarkers.find(j => j.id === e);
    
            if (!mapMarker) {
                return true;
            }
    
            if (!floorplanBounds.contains(mapMarker.map_marker.getLatLng())) {
                return true;
            }
        }

        return false;
    };

    public render() {
        const { classes, className, floorplanName, floorplanPayload } = this.props;

        const {
            isFullScreen,
            partialOperations,
            isSavingChanges,
            isWarning,
            warningText,
            isAddingNewMarker,
            leafletMarkers,
            markerSearch,
            isEditingMarker,
            selectedMarker,
            isMarkerListOpened,
            isAddButtonClicked
        } = this.state;

        const isLeafletReady = floorplanPayload.is_leaflet_ready;
        
        return (
            <div
                className={`${classes.root} ${className} ${
                    isFullScreen ? classes.fullScreenContainer : ''
                }`}
                data-testid="leaflet-client"
            >
                <div className={classes.container}>
                    <div
                        className={`${
                            isFullScreen
                                ? classes.buttonContainerFullscreen
                                : classes.buttonContainer
                        } ${classes.flexItem}`}
                    >
                        <Button
                            className={classes.buttonFullscreen}
                            onClick={this.onFullscreenClick}
                            data-testid="leaflet-client-fullscreen"
                        >
                            {isFullScreen ? <FullscreenExit /> : <Fullscreen />}
                        </Button>
                        <Typography
                            variant="h6"
                            className={`${classes.heading} ${classes.ellipsis}`}
                        >
                            {floorplanName} floorplan
                        </Typography>
                        <div
                            className={`${classes.flexItem} ${classes.leafletClientFlag}`}
                        >
                            <InfoOutlined
                                className={`${
                                    isLeafletReady
                                        ? classes.readyItem
                                        : classes.warningItem
                                }`}
                            />
                            <small
                                className={`${
                                    isLeafletReady
                                        ? classes.readyText
                                        : classes.warningText
                                }`}
                            >
                                {isLeafletReady
                                    ? 'This PDF is using LEAFLET instead of XFDF'
                                    : 'This PDF is still using XFDF'}
                            </small>
                        </div>
                        {partialOperations.length > 0 && (
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.buttonExport}
                                onClick={this.onFinishMarkerOperations}
                                disabled={this.checkCanSaveChanges()}
                            >
                                {isSavingChanges
                                    ? 'Processing...'
                                    : 'Save Changes'}
                            </Button>
                        )}
                    </div>
                    {isWarning && (
                        <Alert
                            severity="warning"
                            className={classes.warningToast}
                            onClose={this.onCloseWarning}
                        >
                            <AlertTitle>Warning</AlertTitle>
                            {warningText}
                        </Alert>
                    )}
                    <Paper className={classes.paperFrame}>
                        <IconButton
                            aria-label="add-a-marker"
                            component="span"
                            className={`
                                ${
                                    isAddButtonClicked
                                        ? classes.addCommentButtonSelected
                                        : classes.addCommentButton
                                }
                                ${
                                    isFullScreen
                                        ? classes.fullScreenAddCommentButton
                                        : ''
                                }
                            `}
                            color={isAddButtonClicked ? 'primary' : 'default'}
                            onClick={this.startAddNewMarker}
                        >
                            <AddCommentOutlined />
                        </IconButton>
                        {
                            !isMarkerListOpened &&
                                <IconButton
                                    aria-label="show-marker-list"
                                    component="span"
                                    className={`
                                        ${classes.showMarkerListButton}
                                        ${
                                            isFullScreen
                                                ? classes.fullScreenShowMarkerListButton
                                                : ''
                                        }
                                    `}
                                    onClick={this.onMarkerListholderHideClick}
                                >
                                    <ForumOutlined />
                                </IconButton>
                        }
                        <div
                            id="map"
                            onKeyDown={this.keyDeleteMarker}
                            className={`${classes.animContainer} ${classes.leafletClientHolder}`}
                        ></div>
                        <div
                            className={`
                                ${classes.animContainer}
                                ${isMarkerListOpened ?
                                    isFullScreen
                                        ? classes.markerListHolderFull
                                        : classes.markerListHolder
                                : classes.markerListHolderHidden
                                }
                            `}
                        >
                            <List
                                component="nav"
                                aria-label="main leaflet markers"
                                className={classes.markerListComponent}
                                subheader={
                                    <ListSubheader
                                        className={classes.listHeader}
                                    >
                                        <Typography
                                            variant="h6"
                                            className={classes.listHeaderText}
                                        >
                                            <IconButton
                                                aria-label="close-marker-list"
                                                size="small"
                                                className={classes.closeMarkerListButton}
                                                onClick={this.onMarkerListholderHideClick}
                                            >
                                                <ClearOutlined />
                                            </IconButton>
                                            <b>Total Markers: </b>{' '}
                                            {leafletMarkers.length}
                                        </Typography>
                                    </ListSubheader>
                                }
                            >
                                <Divider />
                                <ListItem>
                                    <TextField
                                        data-testid="account-searchbar"
                                        className={classes.searchInput}
                                        type="text"
                                        placeholder="Search by name"
                                        variant="outlined"
                                        multiline={false}
                                        value={markerSearch}
                                        InputProps={{
                                            endAdornment: (
                                                <React.Fragment>
                                                    {markerSearch !== '' && (
                                                        <IconButton
                                                            aria-label="cancel"
                                                            data-testid="cancel-search"
                                                            onClick={
                                                                this
                                                                    .onCancelSearch
                                                            }
                                                        >
                                                            <ClearOutlined />
                                                        </IconButton>
                                                    )}
                                                    <IconButton
                                                        aria-label="search"
                                                        data-testid="commit-search"
                                                    >
                                                        <SearchOutlined />
                                                    </IconButton>
                                                </React.Fragment>
                                            )
                                        }}
                                        onChange={this.onMarkerNameSearch}
                                    />
                                </ListItem>
                                <Divider />
                                {this.formatMarkerItemList().map(m => {
                                    return (
                                        <React.Fragment>
                                            {isEditingMarker &&
                                            selectedMarker &&
                                            selectedMarker.id === m.id ? (
                                                <ListItem
                                                    id={m.id}
                                                    key={`marker-${m.id}`}
                                                    className={classes.markerListEditItem}
                                                >
                                                    <ListItemText
                                                        primary={m.id}
                                                    />
                                                    <TextField
                                                        data-testid={`edit-marker-input-${m.id}`}
                                                        className={classes.editMarkerInput}
                                                        type="text"
                                                        placeholder={
                                                            isAddingNewMarker
                                                                ? 'Type new marker name'
                                                                : 'Marker name'
                                                        }
                                                        variant="outlined"
                                                        multiline={false}
                                                        value={selectedMarker.name}
                                                        onChange={this.onMarkerEditChange}
                                                        onKeyDown={e => this.onMarkerEditSubmit(true,e)}
                                                        onBlur={this.onMarkerInputBlur}
                                                        autoFocus={true}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <React.Fragment>
                                                                    <IconButton
                                                                        aria-label="submit"
                                                                        data-testid="commit-submit"
                                                                        color="primary"
                                                                        onClick={e =>
                                                                            this.onMarkerEditSubmit(
                                                                                false
                                                                            )
                                                                        }
                                                                    >
                                                                        <SendOutlined />
                                                                    </IconButton>
                                                                </React.Fragment>
                                                            )
                                                        }}
                                                    />
                                                </ListItem>
                                            ) : (
                                                <ListItem
                                                    id={m.id}
                                                    key={`marker-${m.id}`}
                                                    className={classes.markerListitem}
                                                    button
                                                    autoFocus={selectedMarker && selectedMarker.id === m.id ? true : false}
                                                    onClick={e => this.onMarkerItemFocus(m)}
                                                    onDoubleClick={e => this.onMarkerStartEditing(m)}
                                                >
                                                    <ListItemText
                                                        primary={m.id}
                                                        secondary={m.name}
                                                    />
                                                    <ListItemIcon
                                                        className={classes.listItemDeleteIcon}
                                                        onClick={e => this.itemDeleteMarker(m)}
                                                    >
                                                        <DeleteForeverOutlined />
                                                    </ListItemIcon>
                                                </ListItem>
                                            )}
                                            <Divider />
                                        </React.Fragment>
                                    );
                                })}
                            </List>
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
}

const MUIComponent = withStyles(styles)(LeafletPDFClient);
export { MUIComponent as LeafletPDFClient };
